// Formato del folio fiscal (UUID) que emite el SAT: 8-4-4-4-12 en hexadecimal.
// Debe coincidir con el de erp_backend/Utils/uuidFactura.utils.js
export const REGEX_UUID_SAT = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

// Solo los valores con formato del SAT se revisan contra duplicados. Los folios
// internos y los campos a medio capturar se dejan pasar sin consultar al servidor.
export const esUuidSat = (uuid) =>
  typeof uuid === "string" && REGEX_UUID_SAT.test(uuid.trim());
